import { useState } from 'react';
import { menuSections } from '../data/menu';

const tagColors = {
  Iconic:   'bg-wine text-light',
  Rare:     'bg-wine text-light',
  New:      'bg-sand text-maroon',
  Seasonal: 'border border-maroon/20 text-maroon/60',
};

export default function Menu() {
  const [active, setActive] = useState('signatures');
  const section = menuSections.find(s => s.id === active);

  return (
    <div className="bg-marron/30 page-enter">

      {/* Header */}
      <div className="bg-maroon px-8 md:px-16 py-20">
        <p className="text-[10px] tracking-[0.25em] uppercase text-white mb-5">Café Menu</p>
        <h1 className="font-serif font-light text-light leading-tight mb-5" style={{ fontSize: 'clamp(2.5rem,5vw,4rem)' }}>
          What We're<br /><em className="text-white">Brewing Today</em>
        </h1>
        <p className="text-sm text-white leading-[1.8] max-w-md">
          Made with the same care as the coffee — fresh, seasonal, honest.
          Prices may vary slightly by location.
        </p>
      </div>

      {/* Section tabs */}
      <div className="flex border-b border-maroon/10 overflow-x-auto bg-offwhite sticky top-[69px] z-40">
        {menuSections.map(s => (
          <button key={s.id} onClick={() => setActive(s.id)}
            className={`px-5 py-5 text-[10px] tracking-[0.15em] uppercase whitespace-nowrap border-b-2 transition-all duration-300 font-medium ${
              active === s.id ? 'border-maroon text-maroon' : 'border-transparent text-maroon/35 hover:text-maroon/65'
            }`}>
            {s.label}
          </button>
        ))}
      </div>

      {/* Items */}
      <div className="px-8 md:px-16 py-14 w-full bg-white">
        <div className="w-full">
          <h2 className="font-serif text-4xl font-light text-maroon mb-12">{section.label}</h2>

          <div className="flex flex-col gap-[10px] w-full">
            {section.items.map((item, i) => (
              <div key={i}
                className="group flex items-start justify-between gap-8 bg-maroon hover:bg-cream transition-colors duration-500 px-7 py-6 w-full cursor-pointer">

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2.5 mb-2 flex-wrap">
                    <span className="font-serif text-lg font-light text-white group-hover:text-maroon transition-colors duration-300">
                      {item.name}
                    </span>

                    {item.tag && (
                      <span className={`text-[9px] font-medium tracking-[0.12em] uppercase px-2 py-0.5 ${tagColors[item.tag] || tagColors.Seasonal}`}>
                        {item.tag}
                      </span>
                    )}

                    <span className={`inline-flex items-center justify-center w-3.5 h-3.5 rounded-sm border-2 flex-shrink-0 ${item.veg ? 'border-green-700' : 'border-red-700'}`}>
                      <span className={`block w-1.5 h-1.5 rounded-full ${item.veg ? 'bg-green-700' : 'bg-red-700'}`} />
                    </span>
                  </div>

                  <p className="text-xs text-white group-hover:text-maroon/70 leading-[1.75] max-w-none transition-colors duration-300">
                    {item.desc}
                  </p>
                </div>

                <div className="font-serif text-lg font-light text-white group-hover:text-maroon flex-shrink-0 mt-0.5 transition-colors duration-300">
                  ₹{item.price}
                </div>
              </div>
            ))}
          </div>

          <p className="text-[11px] text-maroon/30 mt-10 leading-relaxed italic">
            All prices inclusive of taxes. Menu and prices may vary across café locations.
            Please inform your server of any allergies before ordering.
          </p>
        </div>
      </div>

      {/* Bottom notes */}
      <div className="grid grid-cols-1 md:grid-cols-3 border-t border-maroon/8 mx-8 md:mx-16 mb-16">
        {[
          { icon: '🌿', title: 'Oat Milk Available', sub: 'At all locations, same price' },
          { icon: '☕', title: 'Beans to Take Home', sub: 'Ask your barista for the retail menu' },
          { icon: '📍', title: 'Menu Varies by City', sub: 'Some items are location-exclusive' },
        ].map((item, i) => (
          <div key={i} className="px-6 py-8 border-r border-maroon/8 last:border-r-0 flex gap-4 items-start">
            <span className="text-lg flex-shrink-0 mt-0.5 opacity-50">{item.icon}</span>
            <div>
              <div className="text-xs font-medium text-maroon/70 mb-1 tracking-wide">{item.title}</div>
              <div className="text-[11px] text-maroon/40 leading-relaxed">{item.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}